import { IModifiersState } from './modifiersContext';
import { ModifiersActionTypes, TModifiersAction } from './modifiersActions';

export const modifiersReducer = (state: IModifiersState, action: TModifiersAction): IModifiersState => {
	switch (action.type) {
		case ModifiersActionTypes.SET_MODIFIERS:
			return {
				...state,
				modifiers: action.payload.modifiers,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifiersActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case ModifiersActionTypes.SET_ID_SELECTED_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: null,
				IDSelectedModifierGroup: null,
				isDisabledModifier: false,
				isRestrictedModifier: false,
				currentPage: 1,
			};
		case ModifiersActionTypes.SET_ID_SELECTED_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				IDSelectedModifierGroup: null,
				isDisabledModifier: false,
				isRestrictedModifier: false,
				currentPage: 1,
			};
		case ModifiersActionTypes.SET_ID_SELECTED_MODIFIER_GROUP:
			return {
				...state,
				IDSelectedModifierGroup: action.payload.IDSelectedModifierGroup,
				currentPage: 1,
			};
		case ModifiersActionTypes.CHANGE_PRICE_FROM:
			return {
				...state,
				priceFrom: action.payload.priceFrom,
				currentPage: 1,
			};
		case ModifiersActionTypes.CHANGE_PRICE_TO:
			return {
				...state,
				priceTo: action.payload.priceTo,
				currentPage: 1,
			};
		case ModifiersActionTypes.TOGGLE_SHOW_ONLY_COMBO_ITEMS:
			return {
				...state,
				isShowOnlyComboItems: !state.isShowOnlyComboItems,
				currentPage: 1,
			};
		case ModifiersActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedCustomer: null,
				IDSelectedRestaurant: null,
				IDSelectedModifierGroup: null,
				priceFrom: '',
				priceTo: '',
				isDisabledModifier: false,
				isRestrictedModifier: false,
				isShowOnlyComboItems: false,
				currentPage: 1,
			};
		case ModifiersActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case ModifiersActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case ModifiersActionTypes.TOGGLE_IS_DISABLED_MODIFIERS:
			return {
				...state,
				isDisabledModifier: !state.isDisabledModifier,
			};
		case ModifiersActionTypes.TOGGLE_IS_RESTRICTED_MODIFIERS:
			return {
				...state,
				isRestrictedModifier: !state.isRestrictedModifier,
			};
		case ModifiersActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case ModifiersActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifiersActionTypes.SET_ID_FOR_FULL_INFO:
			return {
				...state,
				IDForFullInfo: action.payload.IDForFullInfo,
			};
		case ModifiersActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifiersActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
